export const fileToBase64 = (file: HTMLInputElement | any): Promise<any> => {
    return new Promise((resolve, reject) => {
        if (file !== null) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        } else {
            reject('Can\'t Convert to base64');
        }
    });
};
